import { useApp } from "@/context/AppContext";

const STYLES = {
  Requested: "bg-[#FEF3C7] text-[#92400E]", Confirmed: "bg-[#DBEAFE] text-[#1E40AF]",
  Completed: "bg-[#D1FAE5] text-[#065F46]", Cancelled: "bg-[#FEE2E2] text-[#991B1B]",
  Open: "bg-[#FEF3C7] text-[#92400E]", "In progress": "bg-[#DBEAFE] text-[#1E40AF]", Resolved: "bg-[#D1FAE5] text-[#065F46]",
  Pending: "bg-[#FEF3C7] text-[#92400E]", Paid: "bg-[#D1FAE5] text-[#065F46]",
  "On the way": "bg-[#E05C3A] text-white", Reached: "bg-[#2E9E6B] text-white",
};

export const StatusBadge = ({ status, testid }) => {
  const { t } = useApp();
  return <span data-testid={testid} className={`inline-block rounded-full px-3 py-1 text-xs font-bold ${STYLES[status] || "bg-gray-100"}`}>{t(status)}</span>;
};

export const StatusSteps = ({ status }) => {
  const { t } = useApp();
  if (status === "Cancelled") return <p className="text-sm font-semibold text-[#991B1B]">{t("This pickup was cancelled.")}</p>;
  const steps = ["Requested", "Confirmed", "Completed"];
  const idx = steps.indexOf(status);
  return (
    <div className="flex items-center gap-1" data-testid="status-steps">
      {steps.map((s, i) => (
        <div key={s} className="flex flex-1 flex-col items-center gap-1">
          <div className={`h-2 w-full rounded-full ${i <= idx ? "bg-[#2E9E6B]" : "bg-[#EAEFEA]"}`} />
          <span className={`text-[11px] font-semibold ${i <= idx ? "text-[#0D3B2B]" : "text-[#7B968B]"}`}>{t(s)}</span>
        </div>
      ))}
    </div>
  );
};
